import { TECH } from "./tech"
import { PROJECTTYPE } from "./projectTypes"
import { PLATFORM } from "./platforms"



export const projects = [

    {
        projectId: "P0007",
        title: "Rialto Labs",
        type: PROJECTTYPE.FRONTEND,
        description: "RialtoLabs is a Dublin-based innovation company founded during the lockdown period, born from collaboration and a shared vision for sustainability. They focus on developing modern, data-driven solutions that advance sustainable technologies in the food and agriculture industry. We have worked together to deliver a quality website that represents what they stand for.",
        emoji: "microscope",
        platform: PLATFORM.WEB,
        link: "https://rialtolabs.com/",
        tech: [
            TECH.FIGMA,
            TECH.TAILWIND,
            TECH.REACT,
            TECH.JAVASCRIPT,
            TECH.GIT,
        ],
        gradient: [
            "#13438A",
            "#3F5F88",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/rialtoLabs/RialtoLabsThumbnail.png"),
        thumbnailAlt:"Rialto Home Screen In A Macbook Screen",
        screenshots: [
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS1.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS2.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS3.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS4.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS5.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/rialtoLabs/screenshots/RLSS6.jpg"),
                isVertical: false,
            },
        ],
        demo: require("../../assets/projects/rialtoLabs/video/RLDemo.webm"),
        demoAlt: "A demo video about RialtoLabs' QuickSafe page",
    },


    {
        projectId: "P0006",
        title: "Matteness Interior",
        type: PROJECTTYPE.FULLSTACK,
        description: "Matteness Interior Design is an interior design firm that is home to an award-winning team of creatives specializing in high-end residential projects. They create beatiful interior designs that are clean and elegant. This website was made to represent their website, showing off an elegant and clean web design reflecting their brand and what they stand for.",
        emoji: "couch-and-lamp",
        platform: PLATFORM.WEB,
        link: "https://mattenessdesign.com",
        tech: [
            TECH.FIGMA,
            TECH.TAILWIND,
            TECH.NEXTJS,
            TECH.JAVASCRIPT,
            TECH.GIT,
        ],
        gradient: [
            "#383838",
            "#202020",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/mattenessInterior/MattenessInteriorDesignThumbnail.png"),
        thumbnailAlt:"Matteness Interior Home Screen in a MacBook Screen",
        screenshots: [
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS1.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS2.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS3.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS4.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS5.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS6.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS7.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/mattenessInterior/screenshots/MIDSS8.jpg"),
                isVertical: false,
            },
        ],
        demo: require("../../assets/projects/mattenessInterior/video/MIDDemo.webm"),
        demoAlt: "A mobile demo video about Matteness Interior Design's website",
    },



    {
        projectId: "P0005",
        title: "Goods",
        type: PROJECTTYPE.FULLSTACK,
        description: "A modern inventory management system that utilises state of the art object detection technology",
        emoji: "package",
        platform: PLATFORM.MOBILE,
        link: "https://github.com/nullVallue/GoodsInventoryManagement",
        tech: [
            TECH.FLUTTER, 
            TECH.FIREBASE,
            TECH.PYTHON,
            TECH.FIGMA,
        ],
        gradient: [
            "#E48C99",
            "#E16580",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/goods/goodsThumbnail.png"),
        thumbnailAlt:"Goods Dashboard Screen In A Phone Screen",
        mobileScreenshots: [
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS1.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS2.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS3.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS4.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS5.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS6.png"),
                isVertical: true,
            },
            {
                src: require("../../assets/projects/goods/screenshots/GoodsSS7.png"),
                isVertical: true,
            },
        ],
        demoMobile: require("../../assets/projects/goods/video/GoodsDemo.mp4"),
        demoMobileAlt: "A mobile demo video about Goods",
    },



    {
        projectId: "P0004",
        title: "Kofee",
        type: PROJECTTYPE.FRONTEND,
        description: "A chill place to have coffee",
        emoji: "hot-beverage",
        platform: PLATFORM.WEB,
        tech: [
            TECH.FIGMA,
        ],
        gradient: [
            "#FFCF51",
            "#E6AB46",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/kofee/kofeeThumbnail.png"),
        thumbnailAlt:"Kofee Landing Page In A Laptop Screen",
        screenshots: [
            {
                src: require("../../assets/projects/kofee/screenshots/KofeeSS1.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/kofee/screenshots/KofeeSS2.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/kofee/screenshots/KofeeSS3.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/kofee/screenshots/KofeeSS4.jpg"),
                isVertical: false,
            },
        ],
    },



    {
        projectId: "P0003",
        title: "Step Interiors",
        type: PROJECTTYPE.FRONTEND,
        description: "One step at a time",
        emoji: "ladder",
        platform: PLATFORM.WEB,
        tech: [
            TECH.FIGMA,
        ],
        gradient: [
            "#F0CB4E",
            "#C57F00",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/stepinterior/stepinteriorThumbnail.png"),
        thumbnailAlt:"Step Interiors Landing Page In A Laptop Screen",
        screenshots: [
            {
                src: require("../../assets/projects/stepinterior/screenshots/StepInteriorSS1.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/stepinterior/screenshots/StepInteriorSS2.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/stepinterior/screenshots/StepInteriorSS3.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/stepinterior/screenshots/StepInteriorSS4.jpg"),
                isVertical: false,
            },
        ],
    },



    {
        projectId: "P0002",
        title: "B-Smart",
        type: PROJECTTYPE.FRONTEND,
        description: "A tuition centre that maximises your child's growth",
        emoji: "brain",
        platform: PLATFORM.WEB,
        tech: [
            TECH.FIGMA,
        ],
        gradient: [
            "#F0CB4E",
            "#F37C80",
        ],
        bgTextColour: "#FFF",
        thumbnail: require("../../assets/projects/bsmart/bsmartThumbnail.png"),
        thumbnailAlt:"B-Smart Landing Page In A Laptop Screen",
        screenshots: [
            {
                src: require("../../assets/projects/bsmart/screenshots/BSmartSS1.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/bsmart/screenshots/BSmartSS2.jpg"),
                isVertical: false,
            },
            {
                src: require("../../assets/projects/bsmart/screenshots/BSmartSS3.jpg"),
                isVertical: false,
            },
        ],
    },



    // {
    //     projectId: "P0001",
    //     title: "Python TTT",
    //     type: PROJECTTYPE.BACKEND,
    //     description: "TicTacToe but CLI",
    //     emoji: "cross-mark",
    //     platform: PLATFORM.CLI,
    //     link: "https://github.com/nullVallue/ticTacToe",
    //     tech: [
    //         TECH.PYTHON,
    //     ],
    //     gradient: [
    //         "#5357D1",
    //         "#0F172A",
    //     ],
    //     bgTextColour: "#FFF",
    //     thumbnail: require("../../assets/projects/pythonTTT/pythonTTTThumbnail.png"),
    //     thumbnailAlt:"3D TicTacToe",
    //     screenshots: [
    //         {
    //             src: require("../../assets/projects/pythonTTT/screenshots/PythonTTTSS1.jpg"),
    //             isVertical: false,
    //         },
    //         {
    //             src: require("../../assets/projects/pythonTTT/screenshots/PythonTTTSS2.jpg"),
    //             isVertical: false,
    //         },
    //         {
    //             src: require("../../assets/projects/pythonTTT/screenshots/PythonTTTSS3.jpg"),
    //             isVertical: false,
    //         },
    //     ],
    // },




]


// class Project {
//     constructor(
//         title,
//         type,
//         description,
//         emoji,
//         platform,
//         tech,
//     ) {
//         this.title = title;
//         this.type = type;
//         this.description = description;
//         this.emoji= emoji;
//         this.platform = platform;
//         this.tech = tech;
//     }
// }


// export const projects = [
//     new Project(
//         "Goods",
//         PROJECTTYPE.fullstack,
//         "A modern inventory management system that utilises state of the art object detection technology",
//         "package",
//         platform.mobile,
//         [
//             tech.flutter,
//             tech.python,
//             tech.firebase,
//             tech.figma
//         ]
//     ),
//     new Project(
//         "Kofee",
//         PROJECTTYPE.frontend,
//         "A chill place to have coffee",
//         "hot-beverage",
//         platform.web,
//         [
//             tech.figma
//         ]
//     ),
// ]